import { ApeironCloseButton, NextImage } from '@apeiron/temp'
import {
  ButtonBase,
  Dialog,
  DialogContent,
  InputBase,
  styled,
  Tooltip,
  TooltipProps
} from '@mui/material'
import InfoSVG from '@public/icons/icon-info.svg'
import { PlanetElementMap } from '@src/components/planet/detail/planetAboutSection/PlanetElementMap'
import React, { useCallback, useState } from 'react'

const Input = styled(InputBase)`
  width: 100%;
  height: 24px;
  background-color: #151615;
  color: #ffffff;
  border-radius: 2px;
  border: none;
  padding: 0 11px;
  font-size: 16px;
  line-height: 16px;
  & .Mui-disabled.Mui-disabled {
    -webkit-text-fill-color: #ffffff;
  }
`

const Title = styled('div')`
  color: #c4c4c4;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 1px;
  margin-left: 11px;
`

const TitleSection = styled('div')`
  display: flex;
`

const IconInfoImage = styled(NextImage)`
  width: 12px;
  height: 12px;
`

const TextTooltip = styled((props: TooltipProps) => {
  const { className, ...rest } = props

  return <Tooltip {...rest} componentsProps={{ tooltip: { className } }} />
})`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: '#FFFFFF';
  background-color: #696c6e;
`

const DialogTitleSection = styled('div')`
  display: flex;
  flex-direction: column;
  background-color: #262829;
`

const StyledCloseButton = styled(ApeironCloseButton)`
  align-self: flex-end;
  margin: 20px;
`

const StyledDialogContent = styled(DialogContent)`
  background-color: #262829;
`

const InfoButton = styled(ButtonBase)`
  margin-left: 9px;
  align-self: center;
`

export const PlanetAboutItem: React.FC<PlanetAboutItemProps> = props => {
  const {
    title,
    value,
    toolTipTitle,
    hideToolTip = false,
    isPlanetElement = false
  } = props

  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const onIconClick = useCallback(() => {
    setIsDialogOpen(true)
  }, [])

  const onDialogClose = useCallback(() => {
    setIsDialogOpen(false)
  }, [])

  return (
    <div>
      <TitleSection>
        <Title>{title}</Title>
        {!hideToolTip && (
          <TextTooltip title={toolTipTitle || ''}>
            <InfoButton onClick={onIconClick} disableRipple>
              <IconInfoImage src={InfoSVG} onClick={onIconClick} />
            </InfoButton>
          </TextTooltip>
        )}
      </TitleSection>
      <Input
        inputProps={{ 'aria-label': `${title}-value` }}
        value={value}
        disabled
      />
      {isPlanetElement && (
        <Dialog open={isDialogOpen} onClose={onDialogClose}>
          <DialogTitleSection>
            <StyledCloseButton onClick={onDialogClose} />
          </DialogTitleSection>
          <StyledDialogContent>
            <PlanetElementMap />
          </StyledDialogContent>
        </Dialog>
      )}
    </div>
  )
}

export type PlanetAboutItemProps = {
  title: string
  value?: string
  toolTipTitle?: string
  hideToolTip?: boolean
  isPlanetElement?: boolean
}
